import { create } from 'zustand';

export enum BannerId {
    ProperlyLink = 'properly-link'
}

type BannerStore = {
    dismissedBanners: Partial<Record<BannerId, boolean>>;
    isBannerDismissed: (bannerId: BannerId) => boolean;
    dismissBanner: (bannerId: BannerId) => void;
    showBanner: (bannerId: BannerId) => void;
};

const useBannerStore = create<BannerStore>()((set, get) => ({
    dismissedBanners: {},
    isBannerDismissed: (bannerId: BannerId) => {
        const state = get();
        return state.dismissedBanners[bannerId] ?? false;
    },
    dismissBanner: (bannerId: BannerId) => {
        set((state) => ({
            dismissedBanners: {
                ...state.dismissedBanners,
                [bannerId]: true,
            },
        }));
    },
    showBanner: (bannerId: BannerId) => {
        set((state) => {
            const { [bannerId]: _, ...rest } = state.dismissedBanners;
            return { dismissedBanners: rest };
        });
    },
}));

export { useBannerStore };
